// src/components/common/FeedbackModal.js
import React from 'react';

/**
 * A reusable modal for showing success or error feedback.
 * @param {string} title - The title of the modal.
 * @param {string} message - The body text of the modal.
 * @param {function} onClose - Function to call when the "OK" button is clicked.
 * @param {boolean} [isError=false] - If true, styles the title and button for an error.
 */
const FeedbackModal = ({ title, message, onClose, isError = false }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
        <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#0b0e14] p-6 shadow-2xl">
            <h3 className={`text-lg font-semibold mb-3 ${isError ? 'text-red-400' : 'text-emerald-400'}`}>{title}</h3>
            <p className="text-sm text-neutral-300 mb-6">{message}</p>
            <button
                onClick={onClose}
                className={`w-full font-semibold py-2 px-4 rounded-lg transition-colors ${isError
                    ? 'bg-red-600 hover:bg-red-500 text-white'
                    : 'bg-cyan-500 hover:bg-cyan-400 text-black'
                    }`}
            >
                OK
            </button>
        </div>
    </div>
);

export default FeedbackModal;